import { request } from "./core";

export type WebPushConfig = { available: boolean; publicKey: string };
export type WebPushSubscriptionPayload = {
  endpoint: string;
  expirationTime: number | null;
  keys: { p256dh: string; auth: string };
};
export type WebPushTestResult = {
  subscriptions: number;
  sent: number;
  failed: number;
};

export function getWebPushConfig() {
  return request<WebPushConfig>("/api/users/me/push-subscriptions/config", { auth: true });
}

export function saveWebPushSubscription(subscription: WebPushSubscriptionPayload) {
  return request<void>("/api/users/me/push-subscriptions/current", {
    method: "PUT",
    auth: true,
    body: JSON.stringify(subscription),
  });
}

export function deleteWebPushSubscription(endpoint: string) {
  return request<void>("/api/users/me/push-subscriptions/current", {
    method: "DELETE",
    auth: true,
    body: JSON.stringify({ endpoint }),
  });
}

export function sendWebPushTestNotification() {
  return request<WebPushTestResult>("/api/users/me/push-subscriptions/test", {
    method: "POST",
    auth: true,
  });
}
